import { TabPanel, Text } from "@chakra-ui/react";
import React from "react";

const Products = () => {
  return (
    <TabPanel>
      <Text>Products</Text>
    </TabPanel>
  );
};

export default Products;
